import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Terminal } from '~/types';
import { cleanupFormValues } from '~/utils';
import TerminalForm from './TerminalForm';
import { FormDrawer } from '~/components';
import { terminals } from '~/routes';
import { usePermissions } from '~/hooks';
import { useTerminalsCreate } from '~/hooks/terminals';

const TerminalCreate: FC = () => {
  const [t] = useTranslation('terminals');

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate } = useTerminalsCreate(handleClose);

  const onFinish = (values: Terminal) => {
    mutate(cleanupFormValues(values));
  };

  const hasAccessCreate = usePermissions('business.terminal.create');
  if (!hasAccessCreate) return null;
  return (
    <>
      <Button onClick={handleOpen} type="primary">
        {t('addTerminal')}
      </Button>
      <FormDrawer
        name={terminals}
        onFinish={onFinish}
        title={t('addTerminal')}
        onClose={handleClose}
        visible={open}
      >
        <TerminalForm name={terminals} />
      </FormDrawer>
    </>
  );
};

export default TerminalCreate;
